import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'card-section-header',
  templateUrl: './card-section-header.component.html',
})
export class CardSectionHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() icon: string = 'fas fa-list';
  @Input() buttonLabel: string;
  @Input() buttonIcon: string;

  @Input() showButton: boolean = true;
  @Input() buttonDisabled: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  public onButtonClick() {
    this.buttonClick.emit();
  }

}
